var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.newsItem
    ? _c("div", { staticClass: "page-article__content" }, [
        _c("div", { staticClass: "page-article__image" }, [
          _c(
            "picture",
            [
              _vm._l(
                _vm.newsItem[
                  _vm.isDeviceMobile ? "mobileImage" : "desktopImage"
                ].sourcesTypes,
                function(sourceType, index) {
                  return _c("source", {
                    key: index,
                    attrs: {
                      srcset:
                        _vm.newsItem[
                          _vm.isDeviceMobile ? "mobileImage" : "desktopImage"
                        ][sourceType],
                      type: "image/" + sourceType
                    }
                  })
                }
              ),
              _c("img", {
                attrs: {
                  src:
                    _vm.newsItem[
                      _vm.isDeviceMobile ? "mobileImage" : "desktopImage"
                    ].jpg,
                  alt: _vm.newsItem.title
                }
              })
            ],
            2
          )
        ]),
        _c(
          "div",
          { staticClass: "page-article__top" },
          [
            _c("h1", { domProps: { textContent: _vm._s(_vm.newsItem.title) } }),
            _c("router-link", { attrs: { to: _vm.newsItem.categoryPageUrl } }, [
              _vm._v(_vm._s(_vm.newsItem.categoryTitle))
            ])
          ],
          1
        ),
        _c("div", {
          staticClass: "page-article__description",
          domProps: { innerHTML: _vm._s(_vm.newsItem.content) }
        }),
        _c(
          "div",
          { staticClass: "page-article__bottom" },
          _vm._l(_vm.itemTags, function(tag) {
            return _c(
              "router-link",
              { key: tag.id, attrs: { to: tag.pageUrl } },
              [_vm._v(_vm._s(tag.title))]
            )
          }),
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }